window.addEventListener('load', function(event) {
  let form = document.forms[0];

  for (let elem of form.elements) {
    elem.style.display = 'none';
  }
  form.submit();
});
